export function classifyAuthorizations(authorizations, username, role = "") {
  let counter;
  let groups = {
    todo: [],
    waiting: [],
    unread: [],
  };

  if (authorizations == null) {
    return [groups, counter];
  }

  authorizations.forEach((item) => {
    if (
      item.requestedBy.toLowerCase() == username.toLowerCase() ||
      item.role.toLowerCase() !== role.toLowerCase()
    ) {
      if (item.processedBy === "") {
        groups.waiting.push(item);
      } else {
        groups.unread.push(item);
      }
    } else if (item.processedBy === "") {
      groups.todo.push(item);
    }
  });

  counter = groups.todo.length + groups.waiting.length;
  //  ponderateListLength(groups);
  return [groups, counter];
}

function ponderateListLength(groups) {
  const g1 = groupLength(groups, "todo");
  const g2 = groupLength(groups, "waiting");
  const g3 = groupLength(groups, "unread");

  if (g1 + g2 + g3 > 9) {
    // find the largest group and remove 1 element and try again
    const max = Math.max(g1, g2, g3);

    if (g1 == max) {
      groups.todo = groups.todo.splice(1);
    }
    if (g2 == max) {
      groups.waiting = groups.waiting.splice(1);
    }
    if (g3 == max) {
      groups.unread = groups.unread.splice(1);
    }

    ponderateListLength(groups);
  }
}

export const AuthorizationStatus = {
  Waiting: "Waiting",
  Authorized: "Authorized",
  Rejected: "Rejected",
};

const groupLength = (groups, name) => groups[name].length;
